
export default address => {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(address)}&travelmode=driving`;
};
